// extract the tagname from userIdeas by # sign
export function extractTags(paragraph: string): string[] {
  const matches = paragraph.match(/#([a-zA-Z0-9_]+)/g)
  if (!matches) {
    return []
  }

  // Remove the '#' prefix and return the tags
  return matches.map(tag => tag.slice(1))
}

// 函数：转义单引号
export function escapeSingleQuotes(str: string): string {
  if (!str || str.length === 0) {
    return ''
  }
  return str.replace(/'/g, '\'\'')
}

// 函数：反转义单引号
export function unescapeSingleQuotes(str: string): string {
  if (!str || str.length === 0) {
    return ''
  }
  return str.replace(/''/g, '\'')
}

/**
 * 判断文本是否超过一行，用于显示tag的more/less按钮
 * @param element HTMLElement
 */
export function isTextTruncated(element?: HTMLElement | null): boolean {
  if (!element) {
    return false
  }

  // 创建一个临时元素来测量文本宽度
  const testElement = document.createElement('div')
  testElement.style.position = 'absolute'
  testElement.style.whiteSpace = 'nowrap'
  testElement.style.visibility = 'hidden'
  testElement.style.fontSize = getComputedStyle(element).fontSize
  testElement.style.fontFamily = getComputedStyle(element).fontFamily
  testElement.textContent = element.textContent

  // 将临时元素添加到文档中
  document.body.appendChild(testElement)
  // 比较宽度
  const isTruncated = testElement.offsetWidth > element.offsetWidth
  document.body.removeChild(testElement)
  return isTruncated
}

export function base64ToFile(base64: string, fileName: string, type: string): File {
  // Decode the base64 string to a binary representation
  const byteString = atob(base64.split(',')[1])

  // Create a Uint8Array from the byte string
  const arrayBuffer = new ArrayBuffer(byteString.length)
  const intArray = new Uint8Array(arrayBuffer)
  for (let i = 0; i < byteString.length; i++) {
    intArray[i] = byteString.charCodeAt(i)
  }

  // Create a blob from the Uint8Array
  const blob = new Blob([intArray], { type })

  // Create and return a file from the blob
  return new File([blob], fileName, { type })
}

export function splitStreamText(streamText: string): string[] {
  return streamText
    .replaceAll('\n', '')
    .split(/<\/character>|<\/Narrator>|<\/mainCharacter>/)
    .filter(segment => segment.trim() !== '')
}

/**
 *
 * @param text text
 * @param tags check if the text is a close tag
 */
export function isCloseTag(text: string, tags: string[]): boolean {
  const validCloseTag = tags.map(tag => `/${tag.toLowerCase()}`)
  return validCloseTag.some(tag => text.toLowerCase().includes(tag))
}
